@if (loginStarted()) {
    <section style="display: none; opacity: 0"></section>
}

@if (!loginStarted()) {
    <div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="center">
        <div id="login-form-wrapper" style="display: flex; height: 100%">
            <div
                id="login-form"
                style="
                    padding-bottom: 32px;
                    max-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                ">
                <div
                    class="logo"
                    [style.width]="logoWidth"
                    fxLayoutAlign="space-around center"
                    style="margin-bottom: 32px; margin-top: 32px">
                    <img alt="" [ngSrc]="logo" priority width="256" height="60" priority />
                </div>
                <div>
                    @if (!showVerifyCode) {
                        <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>{{ 'LOGIN.USERNAME' | translate }}</mat-label>
                                <input
                                    matInput
                                    focused
                                    placeholder="{{ 'LOGIN.USERNAME' | translate }}"
                                    formControlName="username"
                                    tabindex="0" />
                                @if (loginForm.get('username').hasError('required')) {
                                    <mat-error>
                                        {{ 'LOGIN.MESSAGE.ERROR.EMAIL_REQUIRED' | translate }}
                                    </mat-error>
                                }
                                @if (
                                    !loginForm.get('username').hasError('required') &&
                                    loginForm.get('username').hasError('username')
                                ) {
                                    <mat-error>
                                        {{ 'LOGIN.MESSAGE.ERROR.EMAIL_NOT_VALID' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>{{ 'LOGIN.PASSWORD' | translate }}</mat-label>
                                <input
                                    matInput
                                    placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
                                    formControlName="password"
                                    autocomplete="off"
                                    [type]="hidePassword ? 'password' : 'text'" />
                                <button
                                    matIconButton
                                    type="button"
                                    tabindex="-1"
                                    (click)="hidePassword = !hidePassword"
                                    matSuffix>
                                    @if (hidePassword) {
                                        <fa-icon
                                            matSuffix
                                            style="font-size: 20px"
                                            [icon]="['fal', 'eye-slash']"></fa-icon>
                                    }
                                    @if (!hidePassword) {
                                        <fa-icon matSuffix style="font-size: 20px" [icon]="['fal', 'eye']"></fa-icon>
                                    }
                                </button>
                                <mat-error>
                                    {{ 'LOGIN.MESSAGE.ERROR.PASSWORD_REQUIRED' | translate }}
                                </mat-error>
                            </mat-form-field>
                            <div
                                class="remember-forgot-password"
                                fxLayout="row"
                                fxLayout.xs="column"
                                fxLayoutAlign="space-between center">
                                <mat-checkbox
                                    class="remember-me"
                                    aria-label="{{ 'LOGIN.REMEMBER_ME' | translate }}"
                                    formControlName="rememberMe">
                                    {{ 'LOGIN.REMEMBER_ME' | translate }}
                                </mat-checkbox>
                                <a
                                    class="forgot-password"
                                    style="cursor: pointer; text-decoration: none"
                                    target="_blank"
                                    href="{{ forgetPasswordUrl }}">
                                    {{ 'LOGIN.FORGET_PASSWORD' | translate }}
                                </a>
                            </div>
                            <button
                                matButton="tonal"
                                style="margin-top: 20px; margin-bottom: 40px"
                                color="secondary"
                                class="submit-button primary"
                                aria-label="LOGIN">
                                {{ 'LOGIN.LOGIN' | translate }}
                            </button>
                        </form>
                    }
                    @if (showVerifyCode) {
                        <form
                            name="loginForm"
                            [formGroup]="loginForm"
                            novalidate
                            (ngSubmit)="onVerifyCodeSubmit()"
                            style="padding-top: 0px">
                            <div
                                fxLayout="column"
                                style="padding: 48px; font-size: x-large"
                                fxLayoutAlign="start center">
                                <span style="line-height: 16px">
                                    {{ timeFormat(counter) }}
                                </span>
                            </div>
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'LOGIN.VERIFICATION_CODE' | translate }}</mat-label>
                                <input
                                    matInput
                                    #verifyCodeInput
                                    placeholder="{{ 'LOGIN.VERIFICATION_CODE' | translate }}"
                                    formControlName="verifyCode"
                                    tabindex="0" />
                            </mat-form-field>
                            <button
                                matButton="tonal"
                                color="secondary"
                                style="margin-top: 20px; margin-bottom: 40px"
                                class="submit-button"
                                aria-label="LOGIN"
                                [disabled]="
                                    loginStarted() || !verifyCodeInput.value || verifyCodeInput.value.length < 5
                                ">
                                {{ 'LOGIN.VERIFY_CODE' | translate }}
                            </button>
                        </form>
                        <div fxLayout="column" fxLayoutAlign="start center" style="padding-bottom: 16px">
                            <button
                                matButton="tonal"
                                style="width: 100%"
                                [disabled]="loginStarted()"
                                (click)="reSendVerifyCode()">
                                {{ 'LOGIN.SEND_VERIFICATION_CODE' | translate }}
                            </button>
                        </div>
                    }
                    <!-- Separator -->
                    <div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="center center" style="padding-bottom: 16px">
                        <mat-divider style="width: 100%"></mat-divider>
                        <span style="width: 100%; white-space: nowrap">{{ 'LOGIN.OR_CONTINUE_WITH' | translate }}</span>
                        <mat-divider style="width: 100%"></mat-divider>
                    </div>
                    <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        style="padding-top: 20px; padding-bottom: 10px"
                        fxLayoutGap="20px">
                        <button style="width: 32px; border-radius: 9999px" aria-label="Google" mat-fab-button>
                            @defer {
                                <asl-google-signin-button
                                    type="icon"
                                    shape="circle"
                                    size="medium"></asl-google-signin-button>
                            }
                        </button>
                        <button
                            style="
                                width: 34px;
                                height: 34px;
                                border-radius: 9999px;
                                border: 1px solid currentColor;
                                border: 1px solid lightgrey;
                                cursor: pointer;
                            "
                            (click)="loginWithFacebook()"
                            aria-label="Facebook"
                            mat-fab-button>
                            <fa-icon style="font-size: 23px; color: #0866ff" [icon]="['fab', 'facebook']"></fa-icon>
                        </button>
                        <button
                            style="
                                width: 34px;
                                height: 34px;
                                border-radius: 9999px;
                                border: 1px solid currentColor;
                                border: 1px solid lightgrey;
                                cursor: pointer;
                            "
                            (click)="loginWithMicrosoft()"
                            aria-label="Microsoft"
                            mat-fab-button>
                            <fa-icon style="font-size: 20px; color: #2672ec" [icon]="['fab', 'microsoft']"></fa-icon>
                        </button>
                    </div>
                    <div style="display: flex; font-size: 8px; color: lightgray; justify-content: center">
                        <span>{{ version }}</span>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        padding-top: 40px;
                        width: 100%;
                        white-space: nowrap;
                        justify-content: center;
                        align-items: center;
                    "
                    id="campus_privacy">
                    <a
                        target="_blank"
                        style="cursor: pointer; text-decoration: none; color: var(--mat-sys-primary)"
                        href="/assets/privacy.html">
                        Privacy Policy
                    </a>
                    <a
                        target="_blank"
                        style="
                            cursor: pointer;
                            text-decoration: none;
                            color: var(--mat-sys-primary);
                            padding-left: 32px;
                        "
                        href="/assets/terms-of-use.html">
                        Terms of Use
                    </a>
                    <a
                        target="_blank"
                        style="
                            cursor: pointer;
                            text-decoration: none;
                            color: var(--mat-sys-primary);
                            padding-left: 32px;
                        "
                        href="https://mersys.io">
                        About Campus
                    </a>
                </div>
            </div>
        </div>
    </div>
}

<ng-template #notification>
    <div style="width: 100%; padding: 16px">
        <div style="text-align: center; color: red; font-size: 16px">A message from system administrator</div>
        <p></p>
        <div>
            <mat-hint>{{ serverInfo?.notification }}</mat-hint>
        </div>
        <p></p>
    </div>
</ng-template>
